import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AddMoviePage from "./AddMoviePage";
import EditMoviePage from "./EditMoviePage";
import MovieListingPage from "./MovieListingPage";
import MovieTagPage from "./MovieTagPage";
import MovieNotePage from "./MovieNotePage";
import EditMovieTagPage from "./MovieTagPage/EditMovieTagPage";
import {
  withPermission,
  Roles,
} from "../../../util/PermissionProvider";

export default function MovieManagementPage(props) {
  const { match } = props;
  return (
    <Switch>
      <Route
        exact
        path={`${match.url}`}
        component={withPermission(
          MovieListingPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/new`}
        component={withPermission(
          EditMoviePage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/edit/:id`}
        component={withPermission(
          EditMoviePage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/tags/edit/:id`}
        component={withPermission(
          EditMovieTagPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/tags`}
        component={withPermission(
          MovieTagPage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route
        path={`${match.url}/notes`}
        component={withPermission(
          MovieNotePage,
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR, Roles.CINEFAN_VIEWER],
          [Roles.SUPERADMIN, Roles.CINEFAN_EDITOR]
        )}
      />
      <Route render={() => <Redirect to={`${match.url}`} />} />
    </Switch>
  );
}
